"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOidcFetch = exports.withOidcFetch = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const vanillaOidc_js_1 = require("./vanilla/vanillaOidc.js");
const defaultConfigurationName = 'default';
const fetchWithToken = (fetch, getOidcWithConfigurationName) => (...params) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const [url, options, ...rest] = params;
    const optionTmp = options ? Object.assign({}, options) : { method: 'GET' };
    let headers = new Headers();
    if (optionTmp.headers) {
        headers = !(optionTmp.headers instanceof Headers)
            ? new Headers(optionTmp.headers)
            : optionTmp.headers;
    }
    const oidc = getOidcWithConfigurationName();
    // @ts-ignore
    const getValidToken = yield oidc.getValidTokenAsync();
    const accessToken = (_a = getValidToken === null || getValidToken === void 0 ? void 0 : getValidToken.tokens) === null || _a === void 0 ? void 0 : _a.accessToken;
    if (!headers.has('Accept')) {
        headers.set('Accept', 'application/json');
    }
    if (accessToken) {
        headers.set('Authorization', `Bearer ${accessToken}`);
        if (!optionTmp.credentials) {
            optionTmp.credentials = 'same-origin';
        }
    }
    const newOptions = Object.assign(Object.assign({}, optionTmp), { headers });
    return yield fetch(url, newOptions, ...rest);
});
const withOidcFetch = (fetch = null, configurationName = defaultConfigurationName) => (WrappedComponent) => (props) => {
    const { fetch: newFetch } = (0, exports.useOidcFetch)(fetch || props.fetch, configurationName);
    return (0, jsx_runtime_1.jsx)(WrappedComponent, Object.assign({}, props, { fetch: newFetch }));
};
exports.withOidcFetch = withOidcFetch;
const useOidcFetch = (fetch = null, configurationName = defaultConfigurationName) => {
    const previousFetch = fetch || window.fetch;
    const getOidc = vanillaOidc_js_1.VanillaOidc.get;
    const getOidcWithConfigurationName = () => getOidc(configurationName);
    const newFetch = fetchWithToken(previousFetch, getOidcWithConfigurationName);
    return { fetch: newFetch };
};
exports.useOidcFetch = useOidcFetch;
//# sourceMappingURL=FetchToken.js.map